<template>
    <header
        class="md-header classic"
        :class="[{ mobile: isMobileSize }, pageClass]"
        :style="adaptiveLogoStyle"
        v-show="showHeader"
    >
        <div
            ref="nav"
            class="header-container"
            role="navigation"
            :class="{ nosticky: isDetail || !sticky }"
            :style="mainText"
        >
            <div class="header-bg" :style="{ background: bgColor }"></div>
            <a class="logo" :href="link" rel="noopener noreferrer">
                <site-img
                    :src="logo || null"
                    :style="{ height: size / 100 + 'em' }"
                    :size="100"
                    dir="height"
                    @load="sizeChange(), mobileImgFontSizeRecalc()"
                    :alt="altText || defaultLogoAlt"
                />
            </a>
            <a
                v-if="subLogo"
                class="logo"
                style="margin-left: 0"
                :href="subLogoLink"
                rel="noopener noreferrer"
            >
                <site-img
                    :src="subLogo || null"
                    :style="{ height: subLogoSize / 100 + 'em' }"
                    :size="100"
                    dir="height"
                    @load="sizeChange(), mobileImgFontSizeRecalc()"
                    :alt="subAltText || defaultSublogoAlt"
                />
            </a>
            <div
                class="nav-container"
                :style="mainText"
                :class="{ show: sideMenuShow }"
            >
                <i
                    class="iconfont icon-close-light"
                    role="button"
                    @click="hideMenu"
                    :aria-label="'Close header menu'"
                ></i>
                <ul class="head-menu">
                    <menu-item
                        v-for="(menu, index) in outMoreMenus"
                        :key="menu.name + index"
                        :menu="menu"
                        arrowIcon="icon-arrow-down"
                        :showMenuArrow="isMobileSize"
                    />
                    <template v-if="isMobileSize">
                        <li
                            v-if="showTranslatePlugin"
                            class="menu-item"
                            @click="showLangMenu"
                        >
                            <div class="menu-language">
                                <div class="item-name">
                                    <i class="iconfont icon-website3"></i>
                                    {{ $t('md-header.language') }}
                                </div>
                                <div class="item-label">
                                    <span v-html="currentLanguageItem.label"></span>
                                    <i class="iconfont icon-next-big"></i>
                                </div>
                            </div>
                        </li>
                        <li
                            v-if="showCurrency"
                            class="menu-item"
                            @click="showCurrencyMenu"
                        >
                            <div class="menu-currency">
                                <div class="item-name">
                                    <i class="iconfont icon-currency"></i>
                                    {{ $t('md-header.currency') }}
                                </div>
                                <div class="item-label">
                                    {{ currentCurrencyLabel }}
                                    <i class="iconfont icon-next-big"></i>
                                </div>
                            </div>
                        </li>
                        <closely-app-download downloadTheme="black" useModule="md-header" class="parent-of-closely" />
                    </template>
                    <li
                        class="menu-item more"
                        :class="{ 'has-child': moreShow }"
                        @mouseenter="calcMoreStyle"
                    >
                        <a
                            :aria-label="'More'"
                            role="button"
                            tabindex="0"
                            rel="noopener noreferrer"
                        >{{ $t('md-header.more') }}</a>
                        <div class="submenu-container">
                            <div class="wrapper" ref="wrapper">
                                <ol
                                    class="submenu hidden-scrollbar"
                                    :style="moreStyle"
                                >
                                    <menu-item
                                        v-for="(menu, index) in moreMenus"
                                        :key="menu.name + index"
                                        :menu="menu"
                                        isMore
                                        arrowIcon="icon-arrow-down"
                                        :showMenuArrow="
                                            isMobileSize
                                        "
                                    />
                                </ol>
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- google translate start -->
                <template v-if="!isMobileSize">
                    <ul
                        v-if="showTranslatePlugin"
                        class="head-language-pc language"
                    >
                        <menu-item
                            :menu="translateMenu"
                            class="item-language language"
                        >
                            <template #first>
                                <span v-html="currentLanguageItem.label"></span>
                                <i class="iconfont icon-expand"></i>
                            </template>
                            <template #second="slotProps">
                                <span
                                    @click="selectLanguage(slotProps.row)"
                                    class="lang-list-item"
                                >
                                    <span>{{ slotProps.row.label }}</span>
                                </span>
                            </template>
                        </menu-item>
                    </ul>
                    <ul v-if="showCurrency" class="head-language-pc currency">
                        <menu-item
                            :menu="curencyMenu"
                            class="item-language currency"
                        >
                            <template #first>
                                <span>{{ currentCurrencyLabel }}</span>
                                <i class="iconfont icon-expand"></i>
                            </template>
                            <template #second="slotProps">
                                <span
                                    @click="selectCurrency(slotProps.row)"
                                    class="lang-list-item"
                                >
                                    <span>{{ slotProps.row.abbr }}({{
                                        slotProps.row.symbol
                                    }})-{{ slotProps.row.name }}</span>
                                    <em
                                        v-show="
                                            currentCurrency ==
                                                slotProps.row.abbr
                                        "
                                        class="iconfont icon-checked-light"
                                    ></em>
                                </span>
                            </template>
                        </menu-item>
                    </ul>
                </template>
                <!-- google translate end -->
                <ul class="head-account">
                    <li
                        v-if="!user && isReallyUser"
                        class="menu-item has-child account-icon-container"
                        @click.capture="headAccountClick"
                    >
                        <span
                            class="iconfont icon-acount-book"
                        ></span>
                        <div class="wrapper">
                            <ol class="submenu">
                                <li class="menu-item">
                                    <span
                                        class="menu-span"
                                    >{{ $t('md-header.myHomes') }}</span>
                                </li>
                                <li class="menu-item">
                                    <span
                                        class="menu-span"
                                    >{{ $t('md-header.myTour') }}</span>
                                </li>
                                <li class="menu-item">
                                    <span
                                        class="menu-span"
                                    >{{ $t('md-header.myFavorites') }}</span>
                                </li>
                                <li class="menu-item">
                                    <span
                                        class="menu-span"
                                    >{{ $t('md-header.mySearches') }}</span>
                                </li>
                            </ol>
                        </div>
                    </li>
                    <li v-if="user" class="menu-item has-child">
                        <a
                            class="menu-user"
                            @click="hideMenu"
                            href="/profile"
                            rel="noopener noreferrer"
                        >
                            <span
                                v-if="isMobileSize"
                                class="first-name"
                            >{{ user.firstName }}</span>
                            <span
                                v-else
                                class="menu-user-initial"
                                :style="{ background: userBackgroundColor }"
                            >{{ initialFirstName }}</span>
                        </a>
                        <div
                            class="wrapper"
                        >
                            <ol class="submenu">
                                <li class="menu-item">
                                    <a
                                        href="/profile?type=MyHomes"
                                        rel="noopener noreferrer"
                                    >{{ $t('md-header.myHomes') }}</a>
                                </li>
                                <li class="menu-item">
                                    <a
                                        href="/profile?type=MyTour"
                                        rel="noopener noreferrer"
                                    >{{ $t('md-header.myTour') }}</a>
                                </li>
                                <li class="menu-item">
                                    <a
                                        href="/profile?type=Favorites"
                                        rel="noopener noreferrer"
                                    >{{ $t('md-header.myFavorites') }}</a>
                                </li>
                                <li class="menu-item">
                                    <a
                                        href="/profile?type=Searches"
                                        rel="noopener noreferrer"
                                    >{{ $t('md-header.mySearches') }}</a>
                                </li>
                                <li class="menu-item">
                                    <a
                                        href="/profile?type=Account"
                                        rel="noopener noreferrer"
                                    >{{
                                        $t('md-header.accountSettings')
                                    }}</a>
                                </li>
                                <closely-app-download
                                    useModule="md-header"
                                    class="parent-of-closely"
                                />
                                <li class="menu-item sign-out menu-item-logout">
                                    <a
                                        @click.prevent="logout"
                                        rel="noopener noreferrer"
                                    >
                                        <!-- <span
                                            class="iconfont icon-logout"
                                        ></span> -->
                                        {{ $t('md-header.signOut') }}</a>
                                </li>
                            </ol>
                        </div>
                        <span
                            v-show="isMobileSize"
                            class="mobile-logout"
                            @click="logout"
                        >{{ $t('md-header.signOut') }}</span>
                    </li>
                    <template v-else>
                        <li
                            class="menu-item item-regist"
                        >
                            <span
                                role="button"
                                tabindex="0"
                                @click="register"
                            >
                                {{ $t('md-header.register') }}
                            </span>
                        </li>
                        <li
                            class="menu-item item-login"
                        >
                            <span
                                role="button"
                                tabindex="0"
                                @click="signIn"
                            >
                                {{ $t('md-header.signIn') }}
                            </span>
                        </li>
                    </template>
                </ul>
                <div
                    v-show="isMobileSize"
                    class="avatar"
                    aria-hidden="true"
                >
                    <span
                        v-if="user"
                        class="menu-user-initial"
                        :style="{ background: userBackgroundColor }"
                    >{{ initialFirstName }}</span>
                    <img-box
                        v-else
                        dir="width"
                        src="https://cdn.chime.me/image/fs/sitebuild/20191014/22/original_443acaca-5168-4559-a498-950408317413.png"
                    />
                </div>
            </div>
            <div
                class="nav-container language"
                :style="mainText"
                v-if="isMobileSize && showTranslatePlugin"
                :class="{ show: showMobileLangMenu }"
            >
                <i
                    class="iconfont icon-close-light"
                    role="button"
                    @click="hideLangMenu"
                    :aria-label="'Hide language menu'"
                ></i>
                <ul class="head-language-mobile">
                    <menu-item
                        class="item-language"
                        v-for="lang in translateMenu.items"
                        :key="lang.name"
                        :menu="{}"
                        :class="{ active: currentLanguage === lang.name }"
                    >
                        <template #first>
                            <span
                                class="lang-list-item"
                                role="button"
                                @click="selectLanguage(lang)"
                            >
                                <span>{{ lang.label }}</span>
                            </span>
                        </template>
                    </menu-item>
                </ul>
            </div>
            <div
                class="nav-container language"
                :style="mainText"
                v-if="isMobileSize && showCurrency"
                :class="{ show: showMobileCurrencyMenu }"
            >
                <i
                    class="iconfont icon-close-light"
                    role="button"
                    @click="hideCurrencyMenu"
                    :aria-label="'Hide language menu'"
                ></i>
                <ul class="head-language-mobile">
                    <menu-item
                        class="item-language"
                        v-for="currency in curencyMenu.items"
                        :key="currency.abbr"
                        :menu="{}"
                        :class="{ active: currentCurrency === currency.abbr }"
                    >
                        <template #first>
                            <span
                                class="lang-list-item"
                                @click="selectCurrency(currency)"
                            >
                                <span>{{ currency.abbr }}({{
                                    currency.symbol
                                }})-{{ currency.name }}</span>
                            </span>
                        </template>
                    </menu-item>
                </ul>
            </div>
            <div
                class="nav-mask"
                @click="closeAllMenu"
                @touchmove.self.prevent
            ></div>
            <div
                class="nav-mask-dark"
                v-show="
                    isMobileSize &&
                        (sideMenuShow || showMobileLangMenu)
                "
            ></div>
            <div
                v-show="isMobileSize"
                class="iconfont icon-menu"
                :style="{
                    color: (mainMenuText && mainMenuText.color) || 'inherit'
                }"
                role="button"
                @click="showMenu(false)"
                :aria-label="'Show header menu'"
            ></div>
        </div>
        <div v-if="!isOverlap" class="header-placeholder">
            <div
                :style="{ height: overlapSize + 'em', minHeight: minHeight }"
            ></div>
        </div>
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </header>
</template>

<script>
import Common from '../index';
import util from '../../../common/util';
export default {
    mixins: [Common],
    watch: {
        sticky() {
            this.init();
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            if (this.sticky) {
                util.topFixedHeight = this.$refs?.nav.offsetHeight ?? 0; 
            } else {
                util.topFixedHeight = 0; 
            }
        }
    },
    computed: {
        minHeight() {
            if (this.isMobileSize) {
                return '33px';
            }
            if (!this.mainMenuText?.fontSize) {
                return `30px`;
            }
            
            let fontsize = this.mainMenuText.fontSize.slice(0, -2);
            return Math.max(30, +fontsize + 12) + 'px';
        }
    }
};
</script>
<style lang="scss">
@import './classic.scss';
</style>
